/* ============ BKS FUSION — prototype (couleurs simili) ============ */
(function(){
'use strict';
var IMG='https://cdn.shopify.com/s/files/1/0400/3086/3513/files/fus-';
function $(id){return document.getElementById(id);}
function eur(n){return n.toFixed(2).replace('.',',')+' €';}

/* ---------- données ---------- */
var COLORS=[
 ['Noir','noir','#111111'],['Blanc','blanc','#f2f2f2'],['Gris','gris','#8c8c8c'],
 ['Rouge','rouge','#e2231a'],['Orange','orange','#e07b16'],['Jaune','jaune','#f7d000'],
 ['Doré','dore','#d9a520'],['Vert','vert','#3bbf2a'],['Turquoise','turquoise','#1bb39a'],
 ['Bleu clair','bleu-clair','#37a0e0'],['Bleu','bleu','#1f4fd0'],['Violet','violet','#7c3aed'],['Rose','rose','#e0249a']
];
function hex(slug){for(var i=0;i<COLORS.length;i++)if(COLORS[i][1]===slug)return COLORS[i][2];return '#666';}
function cname(slug){for(var i=0;i<COLORS.length;i++)if(COLORS[i][1]===slug)return COLORS[i][0];return slug;}
/* couleurs RÉELLES dispo par zone/matière (calques <zone>-<matière>-<couleur>.webp existent) */
var MATCOLS={
  dessus:{Carbone:['noir','blanc'],Alcantara:['noir','bleu','rouge','jaune','turquoise','violet','orange']},
  cote:{Alcantara:['noir','bleu','rouge','jaune','turquoise','violet','orange']},
  arrondi:{Alcantara:['noir','bleu','rouge','jaune','turquoise','violet','orange']},
  bands:{Carbone:['noir','bleu','rouge','violet'],Alcantara:['noir','bleu','rouge','jaune','turquoise','violet'],Chrome:['rouge','bleu','or','orange','rose','turquoise','vert','violet']}
};
var ALLCOL=['noir','blanc','gris','rouge','orange','jaune','dore','vert','turquoise','bleu-clair','bleu','violet','rose'];
function colHex(s){return s==='or'?'#d9a520':hex(s);}
function colName(s){return s==='or'?'Or':(s==='holo'?'Holo':cname(s));}
/* zones où la finition Holo est proposée via le sélecteur de matière (aucune : holo bandes gérée à part, liseré = simili uniquement) */
var HOLOZONES={};
/* matières RÉELLEMENT proposables = Simili + celles dont on a les calques (MATCOLS) + Holo si dispo.
   On n'affiche jamais une matière sans calque : elle rendrait un simili tout en facturant le supplément. */
function zoneMats(zone){
  var m=['Simili'].concat(Object.keys(MATCOLS[zone]||{}));
  if(HOLOZONES[zone])m.push('Holo');
  return m;
}
function colsFor(zone,mat){
  if(mat==='Simili')return ALLCOL;
  if(mat==='Holo')return null;                               // holo (liseré) = finition unique
  if(MATCOLS[zone]&&MATCOLS[zone][mat])return MATCOLS[zone][mat];
  return ALLCOL;                                             // matière sans calque -> couleurs simili (visuel placeholder)
}
function slugFor(zone,mat,col){
  if(mat==='Simili')return col;
  if(mat==='Holo')return 'holo';
  if(MATCOLS[zone]&&MATCOLS[zone][mat]&&MATCOLS[zone][mat].indexOf(col)>=0)return mat.toLowerCase()+'-'+col;
  return col;                                                // pas encore de calque -> visuel simili
}

/* ===== BANDES : catalogue de finitions mélangeables (1 choix par bande) =====
   chaque valeur est directement le suffixe du calque grip{i}-<valeur>.webp
   simili -> 'rouge' ; matières -> 'carbone-noir' / 'alcantara-bleu' / 'chrome-or' / 'holo' */
var BANDFIN=ALLCOL
  .concat(MATCOLS.bands.Carbone.map(function(c){return 'carbone-'+c;}))
  .concat(MATCOLS.bands.Alcantara.map(function(c){return 'alcantara-'+c;}))
  .concat(MATCOLS.bands.Chrome.map(function(c){return 'chrome-'+c;}))
  .concat(['holo']);
function finVignette(sl){
  if(sl==='holo')return IMG+'sw-holo.webp';
  if(/^(carbone|alcantara|chrome)-/.test(sl))return IMG+'sw-'+sl+'.webp';
  return null;                                               // simili -> couleur unie
}
function finBg(sl){var v=finVignette(sl);return v?'url('+v+') center/cover':colHex(sl);}
function finName(sl){   // libellé COURT pour les pastilles de l'interface
  if(sl==='holo')return 'Holo';
  var m=/^(carbone|alcantara|chrome)-(.+)$/.exec(sl);
  if(m)return colName(m[2])+' '+{carbone:'Carbone',alcantara:'Alcantara',chrome:'Chrome'}[m[1]];
  return colName(sl);
}
function matLabel(m){ return m==='Simili'?'Simili cuir':m; }
function finFull(sl){   // libellé COMPLET (avec la matière) pour le récap et la commande
  if(sl==='holo')return 'Holographique';
  var m=/^(carbone|alcantara|chrome)-(.+)$/.exec(sl);
  if(m)return colName(m[2])+' · '+{carbone:'Carbone',alcantara:'Alcantara',chrome:'Chrome'}[m[1]];
  return colName(sl)+' · Simili cuir';
}
function finPrice(sl){
  if(sl==='holo')return P.bands.Holo;
  if(/^carbone-/.test(sl))return P.bands.Carbone;
  if(/^alcantara-/.test(sl))return P.bands.Alcantara;
  if(/^chrome-/.test(sl))return P.bands.Chrome;
  return 0;                                                  // simili
}
/* modèles repris des variantes du produit "Housse 50cc mécaboite [2D]" (catalogue réel BKS) */
var MODELES=[
 'Aprilia SX (Depuis 2018)','Aprilia SX/RX (2006-2017)',
 'Beta (Depuis 2021)','Beta (2011-2020)','Beta (2005-2010)',
 'CPI 2005-2015',
 'Derbi Senda (Depuis 2018)','Derbi Senda (2011-2017)','Derbi Senda (2000-2010)',
 'Derbi DRD Evo (2008-2010)','Derbi DRD Pro (2006-2014)','Derbi DRD Pro "selle a étage" (2006-2014)',
 'Derbi DRD Racing (Depuis 2018)','Derbi DRD Racing (2011-2017)','Derbi DRD Racing (2005-10)',
 'Derbi DRD Xtrem (Depuis 2018)','Derbi DRD Xtrem (2011-2017)','Derbi DRD Xtrem (2000-2010)',
 'Derbi DRD Xrace (2000-2010)',
 'Fantic tout modèle (Depuis 2017)','Fantic tout modèle (1997-2016)',
 'Generic Trigger (2006-2016)',
 'Gilera SMT (Depuis 2018)','Gilera SMT (2011-2017)','Gilera SMT (2003-2010)',
 'Honda HM (Depuis 1999)',
 'Masai (SM/Ultimate/Enduro/Razer) (Depuis 2012)',
 'Husqvarna (Tout modèle) 2002-2013',
 'Peugeot XP7 (2011-2015)','Peugeot XP6/XPS (Tout modèle) (Depuis 2004)','Peugeot XP6/XPS (Tout modèle)(1997-2003)',
 'Rieju MRT/MRT Pro (Depuis 2009)','Rieju MRX/SMX/RRX (2001-2009)',
 'Sherco (Depuis 2013)','Sherco (2006-2012)','Sherco (1998-2005)',
 'Vent (Tout Modèle) (Depuis 2018)',
 'Yamaha DT/DTR/DTX (2003-2011)','Yamaha DT (1996-2002)',
 'MBK X-limit (2003-2011)','MBK X-Limit (1996-2002)',
 'Autre 50cc…'
];

/* ---- repris de la Selle Custom (mêmes vignettes CDN Shopify) ---- */
var SCDN='https://cdn.shopify.com/s/files/1/0400/3086/3513/files/';
function scim(n){return SCDN+'sc-'+n+'.webp';}
var FILS=[
  ['Blanc','coutures-blanc','#f2f2f2'],['Noir','coutures-noir','#111111'],['Gris','coutures-gris','#8c8c8c'],
  ['Rouge','coutures-rouge','#e2231a'],['Orange','coutures-orange','#e07b16'],['Jaune','coutures-jaune','#f2d20a'],
  ['Jaune fluo','coutures-jaune-fluo','#d8f21a'],['Doré','coutures-dore','#c9a227'],['Vert','coutures-vert','#3bbf2a'],
  ['Turquoise','coutures-turquoise','#1bb39a'],['Bleu','coutures-bleu','#1f4fd0'],['Violet','coutures-violet','#7c3aed'],
  ['Rose','coutures-rose','#e0249a']
];
/* réseaux sociaux (repris du configurateur 2D ; logo brodé, non affiché sur l'aperçu) */
var SOC=[['Aucun','aucun',''],['TikTok','tiktok','social-tiktok'],['Insta','insta','social-insta'],['Snap','snap','social-snap']];
function socName(k){for(var i=0;i<SOC.length;i++)if(SOC[i][1]===k)return SOC[i][0];return '';}

var BASE=76.90;
var PACK_PRIX=17.82;   // pack entretien (upsell, -10%)
/* variantes Shopify pour le panier */
var BASE_VAR=54359210426709;   // SELLE FUSION (76,90 €)
var OPT_VAR=54359311515989;    // Options Selle FUSION (1 €) — brique de prix (× nb d'euros d'options)
var PACK_VAR=54119771603285;   // Pack entretien (17,82 €) — repris de la Selle Custom
var P={
  dessus:{Simili:0,Carbone:15,Alcantara:50},
  cote:{Simili:0,Carbone:15,Alcantara:60},
  arrondi:{Simili:50,Carbone:55,Alcantara:35},
  bands:{Simili:0,Carbone:10,Alcantara:20,Chrome:25,Holo:25},
  lisgrip:{Simili:20,Carbone:25,Alcantara:30,Chrome:25,Holo:25},
  lislat:{Simili:10,Carbone:15,Alcantara:20},
  brodAv:20, brodLat:35, nfc:10
};

var C={
  model:'',
  dessus:{c:'rouge',m:'Simili'},
  cote:{c:'noir',m:'Simili'},
  arrondi:{on:false,m:'Simili',c:'noir'},
  bands:{mode:'uni',c:['blanc','rouge','blanc','rouge','blanc']},
  lisgrip:{on:false,c:'blanc',m:'Simili'},
  lislat:{on:false,c:'blanc',m:'Simili'},
  couture:{fil:'Blanc'},
  social:'aucun',
  nfc:{on:false,url:''},
  pack:false,
  touched:{dessus:false,bands:false,couture:false,logo:false},   // choix obligatoires réellement faits par le client
  logo:{c:'blanc'},
  brodAv:{t:'',c:'blanc'},
  brodLat:{t:'',c:'blanc'}
};
var cur=0;
var STEPS=[
 {ic:'🏍️',lb:'Ta moto'},{ic:'🎨',lb:'Dessus'},{ic:'🔲',lb:'Côtés'},{ic:'〰️',lb:'Bandes'},
 {ic:'✨',lb:'Liserés'},{ic:'🪡',lb:'Couture'},{ic:'🧵',lb:'Broderies'},{ic:'🧾',lb:'Récap'}
];

/* ---------- prix ---------- */
function pDessus(){return P.dessus[C.dessus.m];}
function pCote(){return P.cote[C.cote.m];}
function pArrondi(){return C.arrondi.on?P.arrondi[C.arrondi.m]:0;}
// prix des bandes = le supplément le plus élevé parmi les 5 finitions affichées (mélange autorisé)
function pBands(){
  var mx=0;
  for(var i=0;i<5;i++){var pr=finPrice(bandColor(i)); if(pr>mx)mx=pr;}
  return mx;
}
function pLisgrip(){return C.lisgrip.on?P.lisgrip[C.lisgrip.m]:0;}
function pLislat(){return C.lislat.on?P.lislat[C.lislat.m]:0;}
function pBrodAv(){return C.brodAv.t.trim()?P.brodAv:0;}
function pBrodLat(){return C.brodLat.t.trim()?P.brodLat:0;}
function pNfc(){return C.nfc.on?P.nfc:0;}
function pPack(){return C.pack?PACK_PRIX:0;}
function total(){return BASE+pDessus()+pCote()+pArrondi()+pBands()+pLisgrip()+pLislat()+pBrodAv()+pBrodLat()+pNfc()+pPack();}

/* ---------- couleur des bandes selon le mode ---------- */
function bandColor(i){
  if(C.bands.mode==='uni')return C.bands.c[0];
  if(C.bands.mode==='alterne')return (i%2===0)?C.bands.c[0]:C.bands.c[1];
  return C.bands.c[i];
}

/* ---------- aperçu ---------- */
function relief(slug){
  // couleur plate + ombre légère pour rester lisible (sans effet de nuance)
  return 'color:'+hex(slug)+';text-shadow:0 1px 2px rgba(0,0,0,.5);';
}
// le texte rétrécit tout seul pour tenir dans sa zone (comme une vraie broderie)
function fitBrod(el,baseCqw,maxPct){
  var stageW=$('stage').clientWidth||520;
  el.style.fontSize=baseCqw+'cqw';
  var w=el.scrollWidth, maxPx=maxPct/100*stageW;
  if(w>maxPx)el.style.fontSize=(baseCqw*maxPx/w).toFixed(2)+'cqw';
}
function paint(){
  function set(id,zone,slug){ var e=$(id); e.src=IMG+zone+'-'+slug+'.webp'; e.style.display=''; }
  function hide(id){ $(id).style.display='none'; }
  set('L_dessus','dessus',slugFor('dessus',C.dessus.m,C.dessus.c));
  set('L_cote','cote',slugFor('cote',C.cote.m,C.cote.c));
  if(C.arrondi.on){ set('L_arrondi','arrondi',slugFor('arrondi',C.arrondi.m,C.arrondi.c)); $('L_arrondi').style.transform='translate(1.29%,-1.29%) scale(1.02)'; } else hide('L_arrondi');
  if(C.lislat.on)set('L_lislat','lislat',slugFor('lislat',C.lislat.m,C.lislat.c)); else hide('L_lislat');
  for(var i=1;i<=5;i++)set('L_grip'+i,'grip'+i,bandColor(i-1)); // valeur = suffixe direct du calque
  if(C.lisgrip.on)set('L_lisgrip','lisgrip',slugFor('lisgrip',C.lisgrip.m,C.lisgrip.c)); else hide('L_lisgrip');
  set('L_logo','logo',C.logo.c);
  // broderies (positions approximatives, ajustables)
  var av=$('B_av');
  if(C.brodAv.t.trim()){ av.textContent=C.brodAv.t.trim().slice(0,4);
    av.setAttribute('style','display:block;left:24%;top:18%;transform:translate(-50%,-50%) rotate(-22deg);'+relief(C.brodAv.c));
    fitBrod(av,3.1,16); }
  else av.style.display='none';
  var lt=$('B_lat');
  if(C.brodLat.t.trim()){ lt.textContent=C.brodLat.t.trim().slice(0,14);
    lt.setAttribute('style','display:block;left:52.4%;top:73.4%;transform:translate(-50%,-50%) rotate(48deg);'+relief(C.brodLat.c));
    fitBrod(lt,2.1,25); }
  else lt.style.display='none';

  $('wm').textContent=C.model?C.model.split(' ')[0]:'FUSION';
  var t=eur(total());
  $('fly').textContent=t;
  var tv=$('tot'); if(tv.textContent!==t){tv.textContent=t;tv.classList.add('bump');setTimeout(function(){tv.classList.remove('bump');},200);}
  $('stp').textContent='Étape '+(cur+1)+'/'+STEPS.length;
  $('bn').textContent=cur===STEPS.length-1?'🛒 Ajouter au panier':'Suivant →';
  var pl=$('pills'); pl.innerHTML='';
  STEPS.forEach(function(s,i){
    var b=document.createElement('button');
    b.className='pill'+(i===cur?' act':'')+(stepDone(i)?' done':'');
    b.innerHTML=s.ic+' '+s.lb; b.onclick=function(){cur=i;render();};
    pl.appendChild(b);
  });
  // centrer la pastille active DANS la barre (défilement horizontal only) — ne bouge jamais la page verticalement
  var act=pl.children[cur];
  if(act){ var pr=pl.getBoundingClientRect(), ar=act.getBoundingClientRect();
    pl.scrollTo({left: pl.scrollLeft + (ar.left - pr.left) - (pr.width - ar.width)/2, behavior:'smooth'}); }
}
// container-type pour les cqw des broderies
$('stage').style.containerType='inline-size';

/* ---------- widgets ---------- */
// fond d'une pastille : vraie vignette photo de la matière (chrome/carbone/alcantara) sinon couleur unie (simili)
// le dessus carbone est TISSÉ (vignette dédiée) alors que les bandes carbone sont FORGÉES
function swBg(mat,col,zone){
  if(col==='holo')return 'url('+IMG+'sw-holo.webp) center/cover';                                    // pastille holo (rainbow)
  if(mat&&mat!=='Simili'&&mat!=='Holo'){
    var slug=(zone==='dessus'&&mat==='Carbone')?'dessus-carbone-'+col:mat.toLowerCase()+'-'+col;
    return 'url('+IMG+'sw-'+slug+'.webp) center/cover';
  }
  return colHex(col);
}
// pastilles couleurs (liste de slugs filtrée) — mat = matière courante, zone pour la bonne vignette
function colrow(cols,sel,onpick,mat,zone){
  var d=document.createElement('div'); d.className='sws';
  (cols||[]).forEach(function(sl){
    var w=document.createElement('div');w.className='swx';
    var s=document.createElement('div');s.className='sw'+(sel===sl?' sel':'');s.style.background=swBg(mat,sl,zone);
    s.onclick=function(){onpick(sl);};
    var l=document.createElement('div');l.className='swlab';l.textContent=colName(sl);
    w.appendChild(s);w.appendChild(l);d.appendChild(w);
  });
  return d;
}
function colmini(cols,sel,onpick,mat){
  var d=document.createElement('div'); d.className='sws';
  (cols||[]).forEach(function(sl){
    var s=document.createElement('div');s.className='sw mini'+(sel===sl?' sel':'');s.style.background=swBg(mat,sl);s.title=colName(sl);
    s.onclick=function(){onpick(sl);};
    d.appendChild(s);
  });
  return d;
}
function swrow(sel,onpick){return colrow(ALLCOL,sel,onpick);}   // palette complète (logo, broderies) — simili
function swmini(sel,onpick){return colmini(ALLCOL,sel,onpick);}
// BANDES : toutes les finitions (couleurs simili + matières) dans un seul sélecteur, mélangeables
function finrow(sel,onpick){
  var d=document.createElement('div'); d.className='sws';
  BANDFIN.forEach(function(sl){
    var w=document.createElement('div');w.className='swx';
    var s=document.createElement('div');s.className='sw'+(sel===sl?' sel':'');s.style.background=finBg(sl);
    s.onclick=function(){onpick(sl);};
    var l=document.createElement('div');l.className='swlab';l.textContent=finName(sl)+(finPrice(sl)?' +'+finPrice(sl)+'€':'');
    w.appendChild(s);w.appendChild(l);d.appendChild(w);
  });
  return d;
}
function finmini(sel,onpick){
  var d=document.createElement('div'); d.className='sws';
  BANDFIN.forEach(function(sl){
    var s=document.createElement('div');s.className='sw mini'+(sel===sl?' sel':'');s.style.background=finBg(sl);
    s.title=finName(sl)+(finPrice(sl)?' (+'+finPrice(sl)+'€)':'');
    s.onclick=function(){onpick(sl);};
    d.appendChild(s);
  });
  return d;
}
// sélecteur de matière : après clic, on remet une couleur valide pour la matière
function matrow(zone,obj){
  var d=document.createElement('div'); d.className='mats';
  zoneMats(zone).forEach(function(m){
    var b=document.createElement('div');b.className='mat'+(obj.m===m?' sel':'');
    var pr=P[zone][m];
    b.innerHTML=m+'<span class="mp">'+(pr?'+ '+pr+' €':'inclus')+'</span>';
    b.onclick=function(){
      obj.m=m; var cols=colsFor(zone,m);
      if(cols&&cols.indexOf(obj.c)<0)obj.c=cols[0];   // couleur scalaire : clamp à la matière
      if(C.touched.hasOwnProperty(zone))C.touched[zone]=true;   // ex : changer la matière du dessus compte comme un choix
      render();
    };
    d.appendChild(b);
  });
  return d;
}
/* bloc "Couleur" filtré selon la matière (ou note si la matière n'a pas de couleur, ex : Holo) */
function matColorBlock(container,zone,obj,onpick){
  var cols=colsFor(zone,obj.m);
  if(!cols){ // matière à finition unique (Holo)
    var n=document.createElement('p');n.className='note';n.style.marginTop='10px';
    n.innerHTML='🌈 <b>'+obj.m+'</b> : finition unique, pas de couleur à choisir.';
    container.appendChild(n);return;
  }
  container.appendChild(mklabel('Couleur'));
  container.appendChild(colrow(cols,obj.c,onpick,obj.m,zone));
}
/* libellé récap/commande d'une zone : "Rouge · Simili cuir", "Noir · Carbone"… (matière toujours écrite) */
function zdesc(zone,obj){
  if(colsFor(zone,obj.m)===null)return matLabel(obj.m);
  return colName(obj.c)+' · '+matLabel(obj.m);
}

/* ---------- rendu des étapes ---------- */
function render(){
  paint();
  var p=$('pane'); p.innerHTML='';

  if(cur===0){
    p.innerHTML='<h2>Ta moto 🏍️</h2><div class="sub">Tous les modèles 50cc. Rien à nous envoyer : on fabrique une housse neuve.</div>'
      +'<label class="lb">Modèle</label><select id="mdl"><option value="">Choisis ton modèle…</option>'
      +MODELES.map(function(m){return '<option'+(C.model===m?' selected':'')+'>'+m+'</option>';}).join('')+'</select>';
    $('mdl').onchange=function(){C.model=this.value;paint();};
  }

  if(cur===1){
    p.innerHTML='<h2>Le dessus 🎨</h2><div class="sub">La grande surface du dessus. Choisis la matière, puis la couleur.</div>';
    p.appendChild(mklabel('Matière'));
    p.appendChild(matrow('dessus',C.dessus));
    matColorBlock(p,'dessus',C.dessus,function(v){C.dessus.c=v;touch('dessus');render();});
  }

  if(cur===2){
    p.innerHTML='<h2>Les côtés 🔲</h2><div class="sub">Les flancs de la selle. Choisis la matière, puis la couleur.</div>';
    p.appendChild(mklabel('Matière'));
    p.appendChild(matrow('cote',C.cote));
    matColorBlock(p,'cote',C.cote,function(v){C.cote.c=v;render();});
    // option arrondi
    var ol=document.createElement('div'); ol.className='optline';
    ol.innerHTML='<div class="on">🏁 Côtés arrondis <span style="color:#cdb6ff;font-size:12px">(dès '+P.arrondi.Simili+' €)</span></div>';
    var sw=document.createElement('div'); sw.className='switch'+(C.arrondi.on?' on':'');
    sw.onclick=function(){C.arrondi.on=!C.arrondi.on;render();};
    ol.appendChild(sw); p.appendChild(ol);
    if(C.arrondi.on){
      p.appendChild(mklabel('Matière de l’arrondi'));
      p.appendChild(matrow('arrondi',C.arrondi));
      matColorBlock(p,'arrondi',C.arrondi,function(v){C.arrondi.c=v;render();});
    }
  }

  if(cur===3){
    p.innerHTML='<h2>Les bandes 〰️</h2><div class="sub">Les 5 bandes grip du dessus. Choisis le style, puis une finition par bande — mélange couleurs, carbone, alcantara, chrome et holo comme tu veux.</div>';
    p.appendChild(mklabel('Style'));
    var tg=document.createElement('div');tg.className='toggle';
    [['uni','Uni'],['alterne','Alterné 🔁'],['par','Par bande']].forEach(function(m){
      var b=document.createElement('button');b.textContent=m[1];
      b.className=(C.bands.mode===m[0]?'sel':'')+((m[0]==='alterne'||m[0]==='par')?' new':'');
      b.onclick=function(){C.bands.mode=m[0];touch('bands');render();};tg.appendChild(b);
    });
    p.appendChild(tg);
    if(C.bands.mode==='uni'){
      p.appendChild(mklabel('Finition des 5 bandes'));
      p.appendChild(finrow(C.bands.c[0],function(v){C.bands.c[0]=v;touch('bands');render();}));
    }else if(C.bands.mode==='alterne'){
      p.appendChild(mklabel('Bandes 1·3·5'));
      p.appendChild(finrow(C.bands.c[0],function(v){C.bands.c[0]=v;touch('bands');render();}));
      p.appendChild(mklabel('Bandes 2·4'));
      p.appendChild(finrow(C.bands.c[1],function(v){C.bands.c[1]=v;touch('bands');render();}));
    }else{
      for(var i=0;i<5;i++){(function(k){
        var card=document.createElement('div');card.className='bandcard';
        card.innerHTML='<div class="bt">Bande '+(k+1)+'</div>';
        card.appendChild(finmini(C.bands.c[k],function(v){C.bands.c[k]=v;touch('bands');render();}));
        p.appendChild(card);
      })(i);}
    }
  }

  if(cur===4){
    p.innerHTML='<h2>Les liserés ✨</h2><div class="sub">Les filets de couleur qui soulignent les formes. Chacun en option.</div>';
    // liseré de grip
    var o1=document.createElement('div');o1.className='optline';
    o1.innerHTML='<div class="on">〰️ Liseré de grip <span style="color:#cdb6ff;font-size:12px">(dès '+P.lisgrip.Simili+' €)</span></div>';
    var s1=document.createElement('div');s1.className='switch'+(C.lisgrip.on?' on':'');s1.onclick=function(){C.lisgrip.on=!C.lisgrip.on;render();};
    o1.appendChild(s1);p.appendChild(o1);
    if(C.lisgrip.on){
      if(zoneMats('lisgrip').length>1){p.appendChild(mklabel('Matière'));p.appendChild(matrow('lisgrip',C.lisgrip));}
      matColorBlock(p,'lisgrip',C.lisgrip,function(v){C.lisgrip.c=v;render();});
    }
    // liseré latéral
    var o2=document.createElement('div');o2.className='optline';o2.style.marginTop='18px';
    o2.innerHTML='<div class="on">➰ Liserés latéraux <span style="color:#cdb6ff;font-size:12px">(dès '+P.lislat.Simili+' €)</span></div>';
    var s2=document.createElement('div');s2.className='switch'+(C.lislat.on?' on':'');s2.onclick=function(){C.lislat.on=!C.lislat.on;render();};
    o2.appendChild(s2);p.appendChild(o2);
    if(C.lislat.on){
      if(zoneMats('lislat').length>1){p.appendChild(mklabel('Matière'));p.appendChild(matrow('lislat',C.lislat));}
      matColorBlock(p,'lislat',C.lislat,function(v){C.lislat.c=v;render();});
    }
  }

  if(cur===5){
    p.innerHTML='<h2>La couture 🪡</h2><div class="sub">Choisis la couleur du fil de couture.</div>';
    p.appendChild(mklabel('Couleur du fil de couture'));
    var fl=document.createElement('div');fl.className='sws';
    FILS.forEach(function(f){
      var w=document.createElement('div');w.className='swx';
      var s=document.createElement('div');s.className='sw'+(C.couture.fil===f[0]?' sel':'');
      s.setAttribute('style','background:'+f[2]+' url('+scim(f[1])+') center/cover;');
      s.onclick=function(){C.couture.fil=f[0];touch('couture');render();};
      var l=document.createElement('div');l.className='swlab';l.textContent=f[0];
      w.appendChild(s);w.appendChild(l);fl.appendChild(w);
    });
    p.appendChild(fl);
  }

  if(cur===6){
    p.innerHTML='<h2>Les broderies 🧵</h2><div class="sub">Numéro à l’avant, logo réseau, puis ton pseudo — chacun avec sa couleur de fil.</div>'
      +'<div class="brodbox"><div class="bt"><span>Broderie avant — numéro</span><span class="bp">'+P.brodAv+' €</span></div>'
      +'<input type="text" id="bav" maxlength="4" placeholder="Ex : 04"><div id="bavf" style="margin-top:9px"></div></div>'
      +'<div id="socbox"></div>'
      +'<div class="brodbox"><div class="bt"><span>Broderie latérale — pseudo</span><span class="bp">'+P.brodLat+' €</span></div>'
      +'<input type="text" id="blt" maxlength="12" placeholder="Ex : TON PSEUDO"><div id="bltf" style="margin-top:9px"></div></div>';
    // logo réseau social (avant le pseudo) — repris du configurateur 2D
    var sb=$('socbox');
    sb.appendChild(mklabel('Logo réseau social (brodé)'));
    var sr=document.createElement('div');sr.className='sws';
    SOC.forEach(function(s){
      var w=document.createElement('div');w.className='swx';
      var d=document.createElement('div');d.className='sw'+(C.social===s[1]?' sel':'');
      if(s[2])d.setAttribute('style','background:#fff url('+IMG+s[2]+'.webp) center/72% no-repeat;');
      else d.setAttribute('style','display:flex;align-items:center;justify-content:center;color:#8a8a8a;font-size:18px;');
      if(!s[2])d.textContent='∅';
      d.onclick=function(){C.social=s[1];render();};
      var l=document.createElement('div');l.className='swlab';l.textContent=s[0];
      w.appendChild(d);w.appendChild(l);sr.appendChild(w);
    });
    sb.appendChild(sr);
    var sh=document.createElement('p');sh.className='note';sh.style.margin='6px 0 2px';
    sh.textContent='Le logo choisi est brodé sur la selle (non affiché sur l’aperçu).';
    sb.appendChild(sh);
    $('bav').value=C.brodAv.t; $('bav').oninput=function(){C.brodAv.t=this.value;paint();};
    $('blt').value=C.brodLat.t; $('blt').oninput=function(){C.brodLat.t=this.value;paint();};
    $('bavf').appendChild(swmini(C.brodAv.c,function(v){C.brodAv.c=v;render();}));
    $('bltf').appendChild(swmini(C.brodLat.c,function(v){C.brodLat.c=v;render();}));
    // option puce NFC — mise en avant "nouveau"
    p.appendChild(nfcBox());
    $('nfcsw').onclick=function(){C.nfc.on=!C.nfc.on;render();};
    if(C.nfc.on){ var nu=$('nfcu'); nu.value=C.nfc.url;
      nu.oninput=function(){C.nfc.url=this.value;nfcHint();paint();}; nfcHint(); }
    p.appendChild(mklabel('Couleur du logo BKS'));
    p.appendChild(swrow(C.logo.c,function(v){C.logo.c=v;touch('logo');render();}));
  }

  if(cur===7){
    var L=[['Selle FUSION (base)',eur(BASE)]];
    if(C.model)L.push(['Modèle',C.model]);
    L.push(['Dessus',zdesc('dessus',C.dessus)+(pDessus()?' (+'+pDessus()+'€)':'')]);
    L.push(['Côtés',zdesc('cote',C.cote)+(pCote()?' (+'+pCote()+'€)':'')]);
    if(C.arrondi.on)L.push(['Côtés arrondis',zdesc('arrondi',C.arrondi)+' (+'+pArrondi()+'€)']);
    var fn=function(s){return finFull(s);};
    var bandTxt=C.bands.mode==='uni'?fn(C.bands.c[0]):(C.bands.mode==='alterne'?fn(C.bands.c[0])+' ⇄ '+fn(C.bands.c[1]):C.bands.c.slice(0,5).map(fn).join(', '));
    L.push(['Bandes ('+C.bands.mode+')',bandTxt+(pBands()?' (+'+pBands()+'€)':'')]);
    if(C.lisgrip.on)L.push(['Liseré de grip',zdesc('lisgrip',C.lisgrip)+' (+'+pLisgrip()+'€)']);
    if(C.lislat.on)L.push(['Liserés latéraux',zdesc('lislat',C.lislat)+' (+'+pLislat()+'€)']);
    L.push(['Fil de couture',C.couture.fil]);
    if(C.social!=='aucun')L.push(['Logo réseau brodé',socName(C.social)]);
    if(C.brodAv.t.trim())L.push(['Broderie avant « '+C.brodAv.t.trim()+' »',colName(C.brodAv.c)+' (+'+P.brodAv+'€)']);
    if(C.brodLat.t.trim())L.push(['Broderie latérale « '+C.brodLat.t.trim()+' »',colName(C.brodLat.c)+' (+'+P.brodLat+'€)']);
    if(C.nfc.on)L.push(['Puce NFC 📲',(C.nfc.url||'—')+' (+'+P.nfc+'€)']);
    L.push(['Logo BKS',colName(C.logo.c)]);
    if(C.pack)L.push(['Pack entretien (-10%)',eur(PACK_PRIX)]);
    p.innerHTML='<h2>Récap 🧾</h2><div class="sub">Vérifie, sauvegarde, ou ajoute au panier.</div>'
      +'<div class="recap">'+L.map(function(x){return '<div class="rr"><span>'+x[0]+'</span><b>'+x[1]+'</b></div>';}).join('')
      +'<div class="rr" style="font-size:16px;border-top:2px solid rgba(255,255,255,.12);margin-top:6px;padding-top:9px"><b>TOTAL</b><b>'+eur(total())+'</b></div></div>'
      +'<div class="savebox"><div class="sbt">💾 Sauvegarde ta selle</div>'
      +'<div class="sbs">Jusqu’à 3 configurations gardées. Reçois-les par email + ton code <b>-10% FUSION10</b> en t’inscrivant.</div>'
      +'<div class="svslots" id="lslots"></div>'
      +'<button type="button" class="sbsave" id="lslot">➕ Enregistrer cette config</button>'
      +'<input type="email" id="lmail" placeholder="ton@email.fr" autocomplete="email">'
      +'<div class="sbrow"><button type="button" class="sbmain" id="lsave">✉️ Recevoir mes selles + mon code -10%</button>'
      +'<button type="button" class="sbalt" id="lcopy">🔗 Copier le lien</button></div>'
      +'<div class="svcap">En t’inscrivant tu acceptes de recevoir tes configs et quelques rappels par email. Zéro spam, désabonnement en 1 clic · <a href="/policies/privacy-policy">Confidentialité</a>.</div>'
      +'<div class="sbok" id="lok"></div>'
      +'<a class="svcta" href="/account/register">🔒 Crée ton compte pour retrouver tes selles</a></div>'
      +'<div class="trust"><span>🤚 Fait main en France</span><span>📦 Rien à envoyer</span><span>🏍️ Tous les 50cc</span><span>🔒 3x/4x sans frais</span></div>'
      // upsell pack entretien — à la fin, juste avant l'ajout au panier
      +'<div class="upsell"><div class="ubadge">🔥 -10% à ne pas manquer</div>'
      +'<div class="uimg" style="background-image:url('+scim('accessoires-pack-nettoyage')+')"></div>'
      +'<div class="ubody"><div class="utitle">Pack entretien — garde ta selle comme au premier jour ✨</div>'
      +'<div class="udesc">2 microfibres + nettoyant simili/alcantara + nourrissant simili.</div>'
      +'<div><span class="uold">19,80 €</span><span class="unew">17,82 €</span></div></div>'
      +'<button class="ubtn'+(C.pack?' added':'')+'" id="packbtn">'+(C.pack?'✓ Ajouté':'+ Ajouter')+'</button></div>';
    renderSaves();
    $('lslot').onclick=function(){
      var a=readSaves(), ok=$('lok');
      if(a.length>=MAXSAVES){ ok.style.color='#ffcf8a'; ok.textContent='📁 3 configs déjà gardées — supprimes-en une pour enregistrer celle-ci.'; return; }
      var snap=cloneC(); if(!snap)return;
      snap._ts=Date.now(); a.push(snap); writeSaves(a); renderSaves();
      ok.style.color='#9be29b'; ok.textContent='✓ Config gardée sur cet appareil ('+readSaves().length+'/3). Laisse ton email pour la recevoir + ton code -10%.';
    };
    $('lsave').onclick=function(){
      var e=$('lmail').value.trim(), self=this, ok=$('lok');
      if(!validEmail(e)){ ok.style.color='#ff8a8a'; ok.textContent='⚠️ Entre un email valide.'; return; }
      if(self.disabled)return;
      if(!readSaves().length){ var s=cloneC(); if(s){ s._ts=Date.now(); writeSaves([s]); renderSaves(); } }
      self.disabled=true; self.textContent='… envoi'; ok.style.color='';
      saveToKlaviyo(e,function(success,saves){
        if(success){ self.textContent='✓ Envoyé'; ok.style.color='#9be29b';
          ok.textContent='✓ C’est bon ! On t’envoie '+(saves&&saves.length>1?'tes '+saves.length+' selles':'ta selle')+' + ton code -10% FUSION10 par email. 🔗 Copie ton lien pour la reprendre.'; }
        else { self.disabled=false; self.textContent='✉️ Réessayer'; ok.style.color='#ff8a8a';
          ok.textContent='⚠️ Oups, l’envoi a coincé. Réessaie dans un instant.'; }
      });
    };
    $('lcopy').onclick=function(){
      var u=saveUrl(), ok=$('lok');
      try{ navigator.clipboard.writeText(u).then(function(){ok.style.color='#9be29b';ok.textContent='🔗 Lien de reprise copié !';},function(){ok.textContent=u;}); }
      catch(e){ ok.textContent=u; }
    };
    $('packbtn').onclick=function(){C.pack=!C.pack;render();};
  }
}
function mklabel(t){var l=document.createElement('label');l.className='lb';l.textContent=t;return l;}

/* ---------- puce NFC (option broderie) ---------- */
function validNfcUrl(u){ return /^https:\/\/[^ ]+\.[^ ]{2,}/i.test((u||'').trim()); }
function nfcHint(){
  var h=$('nfchint'); if(!h)return; var u=(C.nfc.url||'').trim();
  if(!u){ h.className='nfchint'; h.innerHTML='🔗 Colle le lien complet, il doit commencer par <b>https://</b>'; }
  else if(validNfcUrl(u)){ h.className='nfchint ok'; h.innerHTML='✓ Lien valide — le téléphone sera redirigé ici.'; }
  else{ h.className='nfchint err'; h.innerHTML='⚠️ Lien incomplet : il doit commencer par <b>https://</b> et contenir un point (ex : https://instagram.com/…).'; }
}
function nfcBox(){
  var box=document.createElement('div'); box.className='nfcbox';
  box.innerHTML='<span class="nfcnew">✨ NOUVEAU</span>'
    +'<div class="nfchead"><div class="nfcic">📲</div>'
    +'<div class="nfctxt"><div class="nfct">Puce NFC connectée <span class="nfcp">+'+P.nfc+' €</span></div>'
    +'<div class="nfcd">Une puce invisible, glissée <b>derrière le logo BKS</b> : on pose son téléphone dessus et hop — redirection directe vers le lien de ton choix (Insta, site, playlist, avis Google…).<br>🔄 <b>Le lien n’est pas définitif</b> : tu pourras le changer toi-même quand tu veux, avec une appli NFC gratuite sur ton téléphone.</div></div>'
    +'<div class="switch'+(C.nfc.on?' on':'')+'" id="nfcsw"></div></div>';
  if(C.nfc.on){
    var w=document.createElement('div'); w.className='nfcurl';
    w.innerHTML='<input type="url" id="nfcu" inputmode="url" autocapitalize="off" autocomplete="off" spellcheck="false" placeholder="https://instagram.com/ton_compte">'
      +'<div class="nfchint" id="nfchint"></div>';
    box.appendChild(w);
  }
  return box;
}

/* ---------- générateur ---------- */
var genDom=[], genAcc=[];   // couleurs dominantes (grosses pièces) / accent (petites touches)
function renderGenRow(elId,arr,max){
  var el=$(elId);el.innerHTML='';
  COLORS.forEach(function(c){
    var w=document.createElement('div');w.className='swx';
    var s=document.createElement('div');s.className='sw'+(arr.indexOf(c[1])>=0?' sel':'');s.style.background=c[2];
    s.onclick=function(){var i=arr.indexOf(c[1]);if(i>=0)arr.splice(i,1);else if(arr.length<max)arr.push(c[1]);renderGen();};
    var l=document.createElement('div');l.className='swlab';l.textContent=c[0];
    w.appendChild(s);w.appendChild(l);el.appendChild(w);
  });
}
function renderGen(){ renderGenRow('gendom',genDom,3); renderGenRow('genacc',genAcc,4); }
// finition bande pour une couleur d'accent, selon la matière voulue (avec repli propre)
function chromeOf(c){return MATCOLS.bands.Chrome.indexOf(c)>=0?'chrome-'+c:null;}
function carboneOf(c){return MATCOLS.bands.Carbone.indexOf(c)>=0?'carbone-'+c:null;}
function alcanOf(c){return MATCOLS.bands.Alcantara.indexOf(c)>=0?'alcantara-'+c:null;}
function shiny(c){return chromeOf(c)||carboneOf(c)||alcanOf(c)||c;}   // brillant : chrome > carbone > alcantara > simili
function soft(c){return alcanOf(c)||carboneOf(c)||c;}                 // mat/doux : alcantara > carbone > simili
function dessusFin(c){return (c==='noir'||c==='blanc')?'carbone-'+c:c;} // dessus texturé si noir/blanc
function miniPreview(cfg){
  function u(z,s){return IMG+z+'-'+s+'.webp';}
  var h='<img src="'+u('dessus',cfg.dessus)+'"><img src="'+u('cote',cfg.cote)+'">';
  if(cfg.arrondi)h+='<img src="'+u('arrondi',cfg.arrondiC||cfg.cote)+'" style="transform:translate(1.29%,-1.29%) scale(1.02)">';
  if(cfg.lislat)h+='<img src="'+u('lislat',cfg.lislat)+'">';
  for(var i=1;i<=5;i++){var col=cfg.bandB?((i%2)?cfg.bandA:cfg.bandB):cfg.bandA;h+='<img src="'+u('grip'+i,col)+'">';}
  if(cfg.lisgrip)h+='<img src="'+u('lisgrip',cfg.lisgrip)+'">';
  h+='<img src="'+u('logo',cfg.logo||'blanc')+'">';
  return h;
}
function cfgPrice(cfg){
  var pr=BASE;
  if(cfg.dessus.indexOf('carbone-')===0)pr+=P.dessus.Carbone;
  if(cfg.arrondi)pr+=P.arrondi.Simili;
  pr+=Math.max(finPrice(cfg.bandA),cfg.bandB?finPrice(cfg.bandB):0);
  if(cfg.lisgrip)pr+=P.lisgrip.Simili;
  if(cfg.lislat)pr+=P.lislat.Simili;
  return pr;
}
function rnd(a){return a[Math.floor(Math.random()*a.length)];}
function shuf(a){a=a.slice();for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;}return a;}
function propose(){
  if(!genDom.length){$('props').innerHTML='<div class="note">Choisis au moins une couleur dominante 👆</div>';return;}
  var doms=shuf(genDom.slice());              // dominantes = grosses pièces : dessus, côté, ARRONDI
  var d1=doms[0], d2=doms[1]||'noir', d3=doms[2]||d1;
  var acc=shuf(genAcc.length?genAcc:[d1==='blanc'?'noir':'blanc']);   // accents = bandes & liserés (jusqu'à 4)
  var a1=acc[0], a2=acc[1]||a1, a3=acc[2]||a1, a4=acc[3]||a2;
  // 1 · épurée — grosses pièces dominantes, petites touches simili (variantes : mode bande, 1 liseré parfois)
  var epUni=Math.random()<0.45;
  var epure={dessus:d1,cote:d2,arrondi:false,
    bandA:a1, bandB:(!epUni&&a2!==a1)?a2:'',
    lisgrip:(Math.random()<0.35?a2:''), lislat:'', logo:'blanc'};
  // 2 · signature — dessus texturé + arrondi (3e dominante) + matières brillantes (holo/chrome) qui varient
  var flashA=rnd(['holo', shiny(a1), chromeOf(a1)||'holo']);
  var flashB=rnd([shiny(a2), soft(a2), (flashA==='holo'?shiny(a1):'holo')]);
  var sig={dessus:dessusFin(d1),cote:rnd([d2,'noir']),arrondi:Math.random()<0.85,arrondiC:d3,
    bandA:flashA, bandB:(flashB!==flashA?flashB:shiny(a2)),
    lisgrip:a2, lislat:rnd([a1,a3,a4]), logo:'blanc'};
  [epure,sig].forEach(function(c){c.price=cfgPrice(c);});
  $('props').innerHTML=
    card('epure','L’ÉPURÉE','Simple & propre','Tes couleurs sur les grosses pièces.',epure,'')
   +card('signature','LA SIGNATURE','Le look complet 🔥','Bandes holo + chrome, liserés, arrondis, dessus texturé.',sig,' hi');
  bindApply('epure',epure);bindApply('signature',sig);
}
function card(id,badge,titre,desc,cfg,cls){
  return '<div class="prop'+cls+'"><span class="pb">'+badge+'</span><h4>'+titre+'</h4><div class="pl">'+desc+'</div>'
   +'<div class="pv">'+miniPreview(cfg)+'</div><div class="foot"><span class="prix">'+eur(cfg.price)+'</span>'
   +'<button class="papp" id="ap-'+id+'">J’applique →</button></div></div>';
}
function bindApply(id,cfg){var b=$('ap-'+id);if(b)b.onclick=function(){apply(cfg);};}
function apply(cfg){
  var dc=cfg.dessus.indexOf('carbone-')===0?{m:'Carbone',c:cfg.dessus.slice(8)}:{m:'Simili',c:cfg.dessus};
  C.dessus.m=dc.m; C.dessus.c=dc.c;
  C.cote.m='Simili'; C.cote.c=cfg.cote;
  C.arrondi.on=cfg.arrondi; C.arrondi.m='Simili'; if(cfg.arrondiC)C.arrondi.c=cfg.arrondiC;
  if(cfg.bandB){C.bands.mode='alterne';C.bands.c[0]=cfg.bandA;C.bands.c[1]=cfg.bandB;}
  else{C.bands.mode='uni';C.bands.c[0]=cfg.bandA;}
  C.lisgrip.on=!!cfg.lisgrip; C.lisgrip.m='Simili'; if(cfg.lisgrip)C.lisgrip.c=cfg.lisgrip;
  C.lislat.on=!!cfg.lislat; C.lislat.m='Simili'; if(cfg.lislat)C.lislat.c=cfg.lislat;
  C.logo.c=cfg.logo||'blanc';
  C.touched.dessus=true; C.touched.bands=true; C.touched.logo=true;   // le générateur a choisi dessus/bandes/logo (reste la couture)
  $('gen').classList.remove('on'); cur=STEPS.length-1; render(); window.scrollTo({top:0,behavior:'smooth'});
}
$('genfab').onclick=function(){$('gen').classList.add('on');renderGen();$('props').innerHTML='';};
$('genclose').onclick=function(){$('gen').classList.remove('on');};
$('genGo').onclick=propose;

/* ---------- sauvegarde par email (capture le mail pour relance) ---------- */
var CONTACT_ACTION='/contact';   // formulaire contact Shopify en prod ; en local le serveur log le lead
function saveUrl(){ try{return location.origin+location.pathname+'?s='+encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(C)))));}catch(e){return location.href;} }
/* ---------- 3 slots de sauvegarde (localStorage) + styles (BKS FUSION) ---------- */
var SAVEKEY='bks_fusion_saves', MAXSAVES=3;
function readSaves(){ try{var r=localStorage.getItem(SAVEKEY);var a=r?JSON.parse(r):[];return Array.isArray(a)?a.slice(0,MAXSAVES):[];}catch(e){return [];} }
function writeSaves(a){ try{localStorage.setItem(SAVEKEY,JSON.stringify((a||[]).slice(0,MAXSAVES)));}catch(e){} }
function cloneC(){ try{return JSON.parse(JSON.stringify(C));}catch(e){return null;} }
function cfgUrl(o){ try{return location.origin+location.pathname+'?s='+encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(o)))));}catch(e){return location.href;} }
function slotName(o){ var mdl=o&&o.model?o.model.split(' ')[0]:'FUSION'; var col=(o&&o.dessus&&o.dessus.c)?colName(o.dessus.c):''; return mdl+(col?' · dessus '+col:''); }
function slotBands(o){ try{ if(!o||!o.bands)return ''; var m=o.bands.mode, cs=o.bands.c||[]; if(m==='uni')return finName(cs[0]); if(m==='alterne')return finName(cs[0])+' ⇄ '+finName(cs[1]); return cs.slice(0,5).map(finName).join(', '); }catch(e){return '';} }
function loadConfig(o){ for(var k in o){ if(C.hasOwnProperty(k))C[k]=o[k]; } }
function renderSaves(){
  var box=$('lslots'); if(!box)return; var a=readSaves(); box.innerHTML='';
  if(!a.length){ box.innerHTML='<div class="svempty">Aucune config gardée pour l’instant. Enregistre celle-ci 👇</div>'; return; }
  a.forEach(function(o,i){
    var row=document.createElement('div'); row.className='svslot';
    row.innerHTML='<div class="svmeta"><span class="svnm">'+(i+1)+'. '+slotName(o)+'</span><span class="svsub">'+(slotBands(o)||'—')+'</span></div>';
    var acts=document.createElement('div'); acts.className='svacts';
    var br=document.createElement('button'); br.type='button'; br.className='svbtn go'; br.textContent='↩︎ Reprendre';
    br.onclick=function(){ loadConfig(o); cur=STEPS.length-1; render(); window.scrollTo({top:0,behavior:'smooth'}); };
    var bl=document.createElement('button'); bl.type='button'; bl.className='svbtn'; bl.textContent='🔗'; bl.title='Copier le lien de cette config';
    bl.onclick=function(){ var u=cfgUrl(o), ok=$('lok'); try{navigator.clipboard.writeText(u).then(function(){if(ok){ok.style.color='#9be29b';ok.textContent='🔗 Lien de cette config copié !';}},function(){if(ok)ok.textContent=u;});}catch(e){if(ok)ok.textContent=u;} };
    var bd=document.createElement('button'); bd.type='button'; bd.className='svbtn del'; bd.textContent='🗑'; bd.title='Supprimer';
    bd.onclick=function(){ var arr=readSaves(); arr.splice(i,1); writeSaves(arr); renderSaves(); };
    acts.appendChild(br); acts.appendChild(bl); acts.appendChild(bd); row.appendChild(acts); box.appendChild(row);
  });
}
(function(){ if(typeof document==='undefined'||document.getElementById('bks-fusion-saves-css'))return;
  var st=document.createElement('style'); st.id='bks-fusion-saves-css';
  st.textContent='.savebox .svslots{display:flex;flex-direction:column;gap:8px;margin:10px 0}'
   +'.svempty{font-size:12.5px;opacity:.75;padding:8px 10px;border:1px dashed rgba(255,255,255,.18);border-radius:10px}'
   +'.svslot{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 10px;border:1px solid rgba(139,92,246,.35);border-radius:10px;background:rgba(139,92,246,.08)}'
   +'.svmeta{display:flex;flex-direction:column;min-width:0}'
   +'.svnm{font-weight:700;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
   +'.svsub{font-size:11.5px;opacity:.7;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'
   +'.svacts{display:flex;gap:5px;flex:0 0 auto}'
   +'.svbtn{border:1px solid rgba(255,255,255,.2);background:rgba(255,255,255,.06);color:inherit;border-radius:8px;padding:6px 8px;font-size:12px;cursor:pointer;line-height:1}'
   +'.svbtn.go{border-color:#8b5cf6;background:rgba(139,92,246,.25);font-weight:700;white-space:nowrap}'
   +'.svbtn.del:hover{border-color:#ff8a8a;color:#ff8a8a}'
   +'.svbtn:hover{filter:brightness(1.15)}'
   +'.sbsave{width:100%;border:1px dashed #8b5cf6;background:rgba(139,92,246,.12);color:inherit;border-radius:10px;padding:10px;font-weight:700;font-size:13px;cursor:pointer;margin:0 0 10px}'
   +'.sbsave:hover{background:rgba(139,92,246,.22)}'
   +'.svcap{font-size:11px;opacity:.68;line-height:1.45;margin-top:8px}'
   +'.svcap a{color:inherit;text-decoration:underline}'
   +'.svcta{display:block;text-align:center;margin-top:10px;font-size:12.5px;font-weight:700;color:#d4af37;text-decoration:none;border-top:1px solid rgba(255,255,255,.1);padding-top:10px}'
   +'.svcta:hover{text-decoration:underline}'
   +'@media(max-width:480px){.svslot{flex-direction:column;align-items:stretch}.svacts{justify-content:flex-end}}';
  (document.head||document.documentElement).appendChild(st);
})();

function restoreFromUrl(){ var m=(location.search||'').match(/[?&]s=([^&]+)/); if(!m)return;
  try{ var o=JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(m[1]))))); for(var k in o)if(C.hasOwnProperty(k))C[k]=o[k]; }catch(e){} }
function validEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }
function captureLead(email,cb){
  var b='Selle FUSION sauvegardée\n\nEmail client : '+email+'\nModèle : '+(C.model||'—')+'\nTotal : '+eur(total())+'\n\nLien de reprise :\n'+saveUrl();
  var pr=new URLSearchParams(); pr.append('form_type','contact'); pr.append('utf8','✓'); pr.append('contact[email]',email); pr.append('contact[body]',b);
  fetch(CONTACT_ACTION,{method:'POST',body:pr}).then(function(){cb(true);}).catch(function(){cb(false);});
}

/* ---------- capture Klaviyo (client-side — PUBLIC company_id UNIQUEMENT) ---------- */
/* SÉCURITÉ : uniquement le public company_id UV7NE3 sur /client/. La clé privée Klaviyo n'apparaît JAMAIS côté client. */
var KLAVIYO_COMPANY='UV7NE3', KLAVIYO_REVISION='2024-10-15', KLAVIYO_LIST='VdWCa9', KLAVIYO_METRIC='Selle FUSION sauvegardée';
function fusionResume(o){
  try{ o=o||C; var fn=function(s){return finName(s);};
    var b=o.bands, bandTxt=b?(b.mode==='uni'?fn(b.c[0]):(b.mode==='alterne'?fn(b.c[0])+' / '+fn(b.c[1]):(b.c||[]).slice(0,5).map(fn).join(', '))):'';
    return [(o.model||'—'),'Dessus '+(o.dessus?colName(o.dessus.c):''),'Bandes '+bandTxt].join(' · ');
  }catch(e){ return (o&&o.model)||'FUSION'; }
}
function klaviyoPost(path,body){
  return fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+KLAVIYO_COMPANY,{method:'POST',headers:{'Content-Type':'application/json','revision':KLAVIYO_REVISION},body:JSON.stringify(body)});
}
function saveToKlaviyo(email,cb){
  var saves=readSaves(); if(!saves.length){ var s0=cloneC(); if(s0){ s0._ts=Date.now(); writeSaves([s0]); saves=readSaves(); } }
  var first=saves[0]||C;
  var props={ Modele:(first.model||'—'), Total:eur(total()), Resume:fusionResume(first), LienReprise:cfgUrl(first), NbSauvegardes:saves.length };
  if(saves[1]){ props.Config2Lien=cfgUrl(saves[1]); props.Config2Resume=fusionResume(saves[1]); }
  if(saves[2]){ props.Config3Lien=cfgUrl(saves[2]); props.Config3Resume=fusionResume(saves[2]); }
  var done=0, okAny=false;
  function fin(){ done++; if(done>=2) cb(okAny, saves); }
  // 1) inscription à la liste (opt-in marketing)
  klaviyoPost('subscriptions',{data:{type:'subscription',attributes:{custom_source:'Configurateur FUSION',profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_LIST}}}}})
    .then(function(r){ okAny=okAny||r.ok; fin(); }).catch(function(){ fin(); });
  // 2) événement métrique (déclenche le flux)
  klaviyoPost('events',{data:{type:'event',attributes:{properties:props,metric:{data:{type:'metric',attributes:{name:KLAVIYO_METRIC}}},profile:{data:{type:'profile',attributes:{email:email}}}}}})
    .then(function(r){ okAny=okAny||r.ok; fin(); }).catch(function(){ fin(); });
  // 3) secours : notification /contact vers la boîte du magasin (best effort)
  try{ captureLead(email,function(){}); }catch(e){}
}

/* ---------- ajout au panier ---------- */
function fusProps(id){
  var fn=function(s){return finName(s);};
  var bandTxt=C.bands.mode==='uni'?fn(C.bands.c[0]):(C.bands.mode==='alterne'?fn(C.bands.c[0])+' ⇄ '+fn(C.bands.c[1]):C.bands.c.slice(0,5).map(fn).join(', '));
  var p={};
  p['Modèle']=C.model||'—';
  p['Dessus']=zdesc('dessus',C.dessus);
  p['Côtés']=zdesc('cote',C.cote);
  if(C.arrondi.on)p['Côtés arrondis']=zdesc('arrondi',C.arrondi);
  p['Bandes ('+C.bands.mode+')']=bandTxt;
  if(C.lisgrip.on)p['Liseré de grip']=zdesc('lisgrip',C.lisgrip);
  if(C.lislat.on)p['Liserés latéraux']=zdesc('lislat',C.lislat);
  p['Fil de couture']=C.couture.fil;
  if(C.social!=='aucun')p['Logo réseau brodé']=socName(C.social);
  if(C.brodAv.t.trim())p['Broderie avant']='« '+C.brodAv.t.trim()+' » · fil '+colName(C.brodAv.c);
  if(C.brodLat.t.trim())p['Broderie latérale']='« '+C.brodLat.t.trim()+' » · fil '+colName(C.brodLat.c);
  if(C.nfc.on)p['Puce NFC — lien à programmer']=C.nfc.url;
  p['Logo BKS']=colName(C.logo.c);
  p['_Lien config']=saveUrl();   // préfixe _ : masqué au client, visible côté commande admin
  p['_bks_id']=id; p['_bks_role']='base';
  return p;
}
function touch(f){ if(C.touched.hasOwnProperty(f))C.touched[f]=true; }
// une étape est "verte" (faite) uniquement quand son choix OBLIGATOIRE est réellement fait
function stepDone(i){
  if(i===0) return !!C.model;
  if(i===1) return C.touched.dessus;
  if(i===3) return C.touched.bands;
  if(i===5) return C.touched.couture;
  if(i===6) return C.touched.logo;
  return false;   // côtés / liserés / récap : optionnels, pas de vert obligatoire
}
// 1er choix obligatoire manquant, ou null si tout est bon
function firstMissing(){
  if(!C.model)                return {step:0,msg:'Choisis ton modèle de moto 🏍️'};
  if(!C.touched.dessus)       return {step:1,msg:'Choisis la couleur / matière du dessus 🎨'};
  if(!C.touched.bands)        return {step:3,msg:'Choisis tes bandes 〰️ (uni, alterné ou par bande)'};
  if(!C.touched.couture)      return {step:5,msg:'Choisis la couleur du fil de couture 🪡'};
  if(!C.touched.logo)         return {step:6,msg:'Choisis la couleur du logo BKS'};
  return null;
}
function addToCart(){
  var miss=firstMissing();
  if(miss){ cur=miss.step; render(); window.scrollTo({top:0,behavior:'smooth'}); alert(miss.msg); return; }
  if(C.nfc.on && !validNfcUrl(C.nfc.url)){ cur=6; render(); window.scrollTo({top:0,behavior:'smooth'});
    var u=$('nfcu'); if(u)u.focus(); alert('📲 Ajoute le lien https:// de ta puce NFC (ou désactive l’option).'); return; }
  var supp=Math.round((total()-BASE-pPack())*100)/100;   // euros d'options (entier)
  var id='FUS-'+Date.now();
  var items=[{id:BASE_VAR,quantity:1,properties:fusProps(id)}];
  if(supp>0)items.push({id:OPT_VAR,quantity:Math.round(supp),properties:{'_bks_id':id,'_bks_role':'brick','Détail':'Options & finitions (+'+Math.round(supp)+' €)'}});
  if(C.pack)items.push({id:PACK_VAR,quantity:1,properties:{'_bks_id':id,'_bks_role':'supp','Détail':'Pack entretien'}});
  items[0].properties['_bks_parts']=String(items.length);
  items[0].properties['_bks_brickqty']=String(supp>0?Math.round(supp):0);   // quantité attendue de la brique Options (anti-fraude)
  var btn=$('bn'); btn.disabled=true; btn.textContent='Ajout…';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){ if(!r.ok)return r.text().then(function(t){throw new Error(t);}); window.location.href='/cart'; })
    .catch(function(e){ btn.disabled=false; btn.textContent='🛒 Ajouter au panier'; alert('L’ajout au panier a échoué. Réessaie, et préviens-nous si ça persiste.'); });
}
$('bn').onclick=function(){ if(cur<STEPS.length-1){cur++;render();window.scrollTo({top:0,behavior:'smooth'});} else addToCart(); };
$('bp').onclick=function(){ if(cur>0){cur--;render();} };
restoreFromUrl();
render();
// recalcule la taille des broderies quand la police SwipeRace est chargée (mesure exacte)
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(paint);
})();
